import {
	Checkbox,
	FormControl,
	FormControlLabel,
	FormHelperText,
	Paper,
	Typography,
} from '@mui/material';
import type { V2AttestationElement } from '../../../types/V2Types';
import type { V2ElementRendererProps } from './elementProps';

export function AttestationElement({
	element,
	value,
	errors,
	disabled,
	onChange,
}: V2ElementRendererProps<V2AttestationElement>) {
	const checked = value === true;
	const errorMessage = errors[0]?.message;

	return (
		<Paper variant="outlined" sx={{ p: 2 }}>
			<Typography variant="subtitle1" gutterBottom>
				{element.label}
			</Typography>
			<Typography variant="body2" sx={{ mb: 1 }}>
				{element.attestationText}
			</Typography>
			<FormControl error={errors.length > 0} required={element.required} disabled={disabled}>
				<FormControlLabel
					control={
						<Checkbox
							checked={checked}
							onChange={(e) => onChange(e.target.checked)}
							data-cy={`hrr-element-${element.elementId}`}
							data-element-type="attestation"
						/>
					}
					label="I confirm"
				/>
				{errorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
			</FormControl>
		</Paper>
	);
}
